module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<form class="forgot-password-form" method="post">\n    <h2>'+
((__t=(t('forgot-password-token::headline')))==null?'':_.escape(__t))+
'</h2>\n    <fieldset>\n        <input name="password" type="text" value="'+
((__t=(t('forgot-password-token::please-wait')))==null?'':_.escape(__t))+
'" disabled />\n    </fieldset>\n    <fieldset class="note">\n    <p class="small">'+
((__t=(t('forgot-password-token::info')))==null?'':_.escape(__t))+
'</p>\n    </fieldset>\n    <fieldset class="submit">\n        <a href="/login" class="btn btn-primary">'+
((__t=(t('forgot-password-token::go-to-login')))==null?'':_.escape(__t))+
'</a>\n    </fieldset>\n</form>';
}
return __p;
};